import React from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../Utils/atoms';

const Survey = () => {
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;
    const outLinks = {
        survey: "https://docs.google.com/forms/d/e/1FAIpQLSfxmOcQooudOi7LoSEnf0I8-uQp-TYstKf--11vlgDIurw3Gg/viewform",
    }

    return (
        <div id="wrap">
            <div className="container">
                <div className="content Survey">
                    {/* 상단 비주얼 */}
                    <div className="visual">
                        <h1>
                            <span className="tit">
                                <img src={`${IMG_URL}/images/survey/tit.png`} alt="images/survey/tit.png" />
                            </span>
                            설문조사
                            <span className="txt">이벤트</span>
                        </h1>
                        <div className="img-visual">
                            <img src={`${IMG_URL}/images/survey/img_visual.png`} alt="images/survey/img_visual.png" />
                        </div>
                    </div>
                    {/* 이벤트 문구 */}
                    <div className="txt-box">
                        비글즈 설문조사에 참여하시고,<br />푸짐한 상품을 받아가세요!
                    </div>
                    {/* 이벤트 안내 */}
                    <div className="event-info howto">
                        <h2>이벤트 안내</h2>
                        <ul>
                            <li>
                                <div className="tit-info">기간</div>
                                <div className="txt">2022년 11월 18일 ~ 12월 2일</div>
                            </li>
                            <li>
                                <div className="tit-info">대상</div>
                                <div className="txt">비글즈 설문조사에 참가하신 분</div>
                            </li>
                            <li>
                                <div className="tit-info">발표</div>
                                <div className="txt">2022년 12월 9일</div>
                            </li>
                        </ul>
                    </div>
                    {/* 상품안내 */}
                    <div className="event-info product">
                        <h2>상품안내</h2>
                        <ol>
                            <li>
                                <div className="ranking">1등</div>
                                <div className="photo">
                                    <figure>
                                        <img src={`${IMG_URL}/images/survey/img_product1.png`} alt="images/survey/img_product1.png" />
                                    </figure>
                                </div>
                                <div className="name">닌텐도 스위치(1명)</div>
                            </li>
                            <li>
                                <div className="ranking">2등</div>
                                <div className="photo">
                                    <figure>
                                        <img src={`${IMG_URL}/images/survey/img_product2.png`} alt="images/survey/img_product2.png" />
                                    </figure>
                                </div>
                                <div className="name">빕스 5만원 기프트 카드(3명)</div>
                            </li>
                            <li>
                                <div className="ranking">3등</div>
                                <div className="photo">
                                    <figure>
                                        <img src={`${IMG_URL}/images/survey/img_product3.png`} alt="images/survey/img_product3.png" />
                                    </figure>
                                </div>
                                <div className="name">스타벅스 아이스<br />아메리카노 (50명)</div>
                            </li>
                        </ol>
                    </div>
                    {/* 이벤트 참여방법 */}
                    <div className="event-info step">
                        <h2>이벤트 참여방법</h2>
                        <ol className="step-list">
                            <li>
                                <h3>STEP1</h3>
                                <p>비글즈 앱 다운로드 받아 사용하기</p>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/survey/img_step1.png`} alt="images/survey/img_step1.png" />
                                    </figure>
                                </div>
                            </li>
                            <li>
                                <h3>STEP2</h3>
                                <p>비글즈 설문조사 참여하기</p>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/survey/img_step2.png`} alt="images/survey/img_step2.png" />
                                    </figure>
                                </div>
                            </li>
                        </ol>
                    </div>
                    {/* 안내 */}
                    <div className="cautionary">
                        <dl>
                            <dt>확인해주세요!</dt>
                            <dd>개인정보 활용 동의 및 설문을 끝까지 완료해 주셔야 이벤트 참가가 완료됩니다.</dd>
                            <dd>응답 해주시는 모든 내용은 통계 목적으로만 집계되며, 다른 용도로는 사용되지 않습니다.</dd>
                            <dd>이벤트 기프티콘은 전화번호를 통해 전송되며, 닌텐도 스위치 경품은 유저님의 주소로 배송됩니다.</dd>
                            <dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
                            <dd>기프티콘 상품은 만료 기간이 존재하는 상품으로 꼭 기간 내 사용을 부탁 드립니다.</dd>
                            <dd>해당 이벤트는 앱스토어 또는 구글 플레이스토어 등과 무관합니다.</dd>
                        </dl>
                    </div>
                    <a href={outLinks.survey} target='_blank' className="btn-join" rel="noopener noreferrer">비글즈 설문조사 참가하기</a>
                </div>
            </div>
        </div>
    );
}

export default Survey;